import React, { useState, useEffect } from 'react';
 
const generateCaptcha = () => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  return Array.from({ length: 7 }, () => characters[Math.floor(Math.random() * characters.length)]).join('');
};
 
const CaptchaInput = ({ onChange, value, onCaptchaTextChange }) => {
  const [captchaText, setCaptchaText] = useState('');
 
  const refreshCaptcha = () => {
    const newCaptcha = generateCaptcha();
    setCaptchaText(newCaptcha);
    onCaptchaTextChange(newCaptcha);
  };
 
  useEffect(() => {
    refreshCaptcha();
  }, []);
 
  return (
    <div className="mb-3 form-body">
      <div className='row'>
        <div className='col-md-4'>
          <label className="form-label">Captcha</label>
        </div>
        <div className='col-md-1'></div>
 
        <div className='col-md-3'>
          <input
            type="text"
            className="form-control"
            placeholder="Captcha"
            value={value}
            onChange={onChange}
          />
        </div>
 
        <div className='col-md-2'>
          <span
            className="captcha-text no-copy"
            onCopy={(e) => e.preventDefault()}
            onCut={(e) => e.preventDefault()}
            onContextMenu={(e) => e.preventDefault()}
          >
            {captchaText}
          </span>
        </div>
 
        <div className='col-md-1 d-flex align-items-center'>
          <button type="button" className="btn btn-outline-secondary captcha-btn" onClick={refreshCaptcha}>
            <b className='refresh-btn'>Refresh</b>
          </button>
        </div>
      </div>
    </div>
  );
};
 
export default CaptchaInput;